<template>
  <div>
    <div class="detial-top">
      <a-descriptions
        :title="
          personDetial.fullName ? '姓名：' + personDetial.fullName : '姓名：'
        "
      >
        <a-descriptions-item label="所在部门">
          {{ personDetial.organizationName || '' }}
        </a-descriptions-item>
        <a-descriptions-item label="身份证号码">
          {{ personDetial.idCardNumber || '' }}
        </a-descriptions-item>
        <a-descriptions-item label="联系电话">
          {{ personDetial.phone || '' }}</a-descriptions-item
        >
        <a-descriptions-item label="人员编号">
          {{ personDetial.personalNumber || '' }}</a-descriptions-item
        >
      </a-descriptions>
      <div class="detial-top-btn">
        <a-dropdown>
          <a-menu slot="overlay" @click="handleMenuClick">
            <a-menu-item key="1_pdf"> 个人信息表 </a-menu-item>
            <a-menu-item key="2_pdf"> 个人履历表</a-menu-item>
          </a-menu>
          <a-button type="primary" icon="file-pdf">
            导出PDF <a-icon type="down" />
          </a-button>
        </a-dropdown>
        <a-dropdown>
          <a-menu slot="overlay" @click="handleMenuClick">
            <a-menu-item key="1_printer"> 个人信息表 </a-menu-item>
            <a-menu-item key="2_printer"> 个人履历表</a-menu-item>
          </a-menu>
          <a-button type="primary" icon="printer">
            打印 <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </div>
    </div>
    <div class="detial-cont">
      <div class="detial-cont-title">工作信息</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions>
          <a-descriptions-item label="行政职务">
            {{ getByTypeName(personDetial.position, positionList) }}
          </a-descriptions-item>
          <a-descriptions-item label="任现职务时间">
            {{ personDetial.positionTime || '' }}
          </a-descriptions-item>
          <a-descriptions-item label="任现职务年限">
            {{ personDetial.positionAge || '' }}
          </a-descriptions-item>
          <a-descriptions-item label="职级">
            {{ getByTypeName(personDetial.positionLevel, positionLevelList) }}
          </a-descriptions-item>
          <a-descriptions-item label="任现职级时间">
            {{ personDetial.positionLevelTime || '' }}
          </a-descriptions-item>
          <a-descriptions-item label="任现职级年限">
            {{ personDetial.positionLevelAge || '' }}
          </a-descriptions-item>
          <a-descriptions-item label="技术职称">
            {{ personDetial.technicalTitle || '' }}
          </a-descriptions-item>
          <a-descriptions-item label="职称聘任时间">
            {{ personDetial.appointmentTime || '' }}
          </a-descriptions-item>
          <a-descriptions-item label="职称获得时间">
            {{ personDetial.acquisitionTime || '' }}
          </a-descriptions-item>
          <a-descriptions-item label="首次参加工作时间">
            {{ personDetial.firstWorkTime || '' }}
          </a-descriptions-item>
          <a-descriptions-item label="进入民政系统时间">
            {{ personDetial.civilOfficeSysTime || '' }}</a-descriptions-item
          >
          <a-descriptions-item label="进入本公司系统时间">
            {{ personDetial.headOfficeSysTime || '' }}
          </a-descriptions-item>
          <a-descriptions-item label="总工龄">
            {{ personDetial.totalSystemAge || '' }}
          </a-descriptions-item>
          <a-descriptions-item label="本单位工龄">
            {{ personDetial.currentOfficeSysAge || '' }}
          </a-descriptions-item>
          <a-descriptions-item label="进入本公司机关时间">
            {{ personDetial.currentOfficeSysTime || '' }}
          </a-descriptions-item>
          <a-descriptions-item label="专业技术职称或技术等级">
            {{ personDetial.technicalTitle || '' }}
          </a-descriptions-item>
          <a-descriptions-item label="军转干部/复原军人">
            {{ personDetial.militaryCadres || '' }}
          </a-descriptions-item>
        </a-descriptions>
        <blank height="40"> </blank>
        <a-descriptions>
          <a-descriptions-item> 合同信息 </a-descriptions-item>
          <br />
          <br />

          <a-descriptions-item label="首次签订合同时间">
            {{ personDetial.firstSignContractTime || '' }}
          </a-descriptions-item>
          <a-descriptions-item label="首次签订合同类型">
            {{
              getByTypeName(personDetial.firstContractType, contractTypeList)
            }}
          </a-descriptions-item>
          <a-descriptions-item label="首次签订合同年限">
            {{ personDetial.firstContractYears }}</a-descriptions-item
          >
          <a-descriptions-item label="首次签订到期时间">
            {{ personDetial.firstContractExpirationTime || '' }}
          </a-descriptions-item>
          <a-descriptions-item label="续订1合同时间">
            {{ personDetial.secondSignContractTime || '' }}</a-descriptions-item
          >
          <a-descriptions-item label="续订1合同类型">
            {{
              getByTypeName(personDetial.secondContractType, contractTypeList)
            }}
          </a-descriptions-item>
          <a-descriptions-item label="续订1合同年限">
            {{ personDetial.secondContractYears || '' }}</a-descriptions-item
          >
          <a-descriptions-item label="续订1到期时间">
            {{ personDetial.secondContractExpirationTime || '' }}
          </a-descriptions-item>
          <a-descriptions-item label="续订2合同时间">
            {{ personDetial.thirdSignContractTime || '' }}</a-descriptions-item
          >
          <a-descriptions-item label="续订2合同类型">
            {{
              getByTypeName(personDetial.thirdContractType, contractTypeList)
            }}
          </a-descriptions-item>
          <a-descriptions-item label="续订2合同年限">
            {{ personDetial.thirdContractYears || '' }}</a-descriptions-item
          >
          <a-descriptions-item label="续订2到期时间">
            {{ personDetial.thirdContractExpirationTime || '' }}
          </a-descriptions-item>
        </a-descriptions>
        <blank height="40"> </blank>
        <div class="personage">
          <div class="personage-title">个人情况</div>
          <div class="personage-cont">
            <a-descriptions style="border-bottom: #e9e9e9 1px solid">
              <a-descriptions-item> 个人基本信息 </a-descriptions-item>
              <br />
              <br />
              <a-descriptions-item label="姓名"
                >{{ personDetial.fullName || '' }}
              </a-descriptions-item>
              <a-descriptions-item label="性别">
                {{ personDetial.sex || '' }}</a-descriptions-item
              >
              <a-descriptions-item label="出生年月">
                {{ personDetial.birthTime || '' }}</a-descriptions-item
              >
              <a-descriptions-item label="年龄">
                {{ personDetial.age || '' }}
              </a-descriptions-item>
              <a-descriptions-item label="民族">
                {{ personDetial.nation || '' }}
              </a-descriptions-item>

              <a-descriptions-item label="籍贯">
                {{ personDetial.nativePlace || '' }}
              </a-descriptions-item>
              <a-descriptions-item label="出生地">
                {{ personDetial.birthplace || '' }}
              </a-descriptions-item>
              <a-descriptions-item label="政治面貌">
                {{
                  getByTypeName(personDetial.politicalType, politicalTypeList)
                }}
              </a-descriptions-item>
              <a-descriptions-item
                label="入党时间"
                v-if="personDetial.joinPartyTime"
              >
                {{ personDetial.joinPartyTime || '' }}
              </a-descriptions-item>
              <a-descriptions-item label="户口所在地">
                {{ personDetial.registeredResidence }}
              </a-descriptions-item>
              <a-descriptions-item label="户口性质">
                {{
                  getByTypeName(
                    personDetial.registeredNature,
                    registeredNatureList
                  )
                }}
              </a-descriptions-item>
              <a-descriptions-item label="健康状况">
                {{ getByTypeName(personDetial.healthStatus, healthStatusList) }}
              </a-descriptions-item>
              <a-descriptions-item label="家庭地址">
                {{ personDetial.homeAddress || '' }}
              </a-descriptions-item>
              <a-descriptions-item label="县区">
                {{ personDetial.county || '' }}
              </a-descriptions-item>
            </a-descriptions>
            <blank height="16"> </blank>
            <a-descriptions>
              <a-descriptions-item> 学历信息 </a-descriptions-item>
              <br />
              <br />
              <a-descriptions-item label="全日制教育学历">
                {{
                  getByTypeName(personDetial.firstEducation, educationList)
                }}</a-descriptions-item
              >
              <a-descriptions-item label="全日制教育学位">
                {{
                  personDetial.firstAcademicDegree || ''
                }}</a-descriptions-item
              >
              <a-descriptions-item label="全日制教育专业">
                {{ personDetial.firstMajor || '' }}</a-descriptions-item
              >

              <a-descriptions-item label="全日制教育毕业院校">
                {{
                  personDetial.firstGraduationSchool || ''
                }}</a-descriptions-item
              >
              <a-descriptions-item label="在职教育学历">
                {{ getByTypeName(personDetial.education, educationList) }}
              </a-descriptions-item>
              <a-descriptions-item label="在职教育学位">
                {{ personDetial.academicDegree || '' }}</a-descriptions-item
              >
              <a-descriptions-item label="在职教育专业">
                {{ personDetial.major || '' }}</a-descriptions-item
              >
              <a-descriptions-item label="在职教育毕业院校">
                {{ personDetial.graduationSchool || '' }}</a-descriptions-item
              >
            </a-descriptions>
            <blank height="16"> </blank>
            <a-descriptions>
              <a-descriptions-item> 退休信息 </a-descriptions-item>
              <br />
              <br />
              <a-descriptions-item label="退休前职务">
                {{ personDetial.retirePosition || '' }}</a-descriptions-item
              >
              <a-descriptions-item label="退休时间">
                {{ personDetial.retireTime || '' }}</a-descriptions-item
              >
              <a-descriptions-item label="退休时身份">
                {{ personDetial.retireIdentity || '' }}</a-descriptions-item
              >

              <a-descriptions-item label="退休类别">
                {{
                  getByTypeName(personDetial.retireType, retireTypeList)
                }}</a-descriptions-item
              >
              <a-descriptions-item label="退休人员档案号">
                {{ personDetial.retireNumber || '' }}</a-descriptions-item
              >
              <a-descriptions-item label="是否社会化管理">
                {{ personDetial.socialManagement || '' }}</a-descriptions-item
              >
              <a-descriptions-item label="社会化社区名称">
                {{ personDetial.socialName || '' }}</a-descriptions-item
              >
              <a-descriptions-item label="紧急联系人">
                {{ personDetial.emergencyContact || '' }}</a-descriptions-item
              >
              <a-descriptions-item label="紧急联系人关系">
                {{
                  personDetial.emergencyContactRelationship || ''
                }}</a-descriptions-item
              >
              <a-descriptions-item label="紧急联系人电话">
                {{
                  personDetial.emergencyContactPhone || ''
                }}</a-descriptions-item
              >
            </a-descriptions>
            <template>
              <blank height="16"> </blank>
              <a-descriptions>
                <a-descriptions-item> 状态信息 </a-descriptions-item>
                <br />
                <br />
                <a-descriptions-item label="状态">
                  {{
                    getByTypeName(
                      personDetial.positionStatus,
                      positionStatusList
                    )
                  }}
                </a-descriptions-item>
                <a-descriptions-item label="减员日期">
                  {{ personDetial.attrtionTiem || '' }}
                </a-descriptions-item>
                <a-descriptions-item label="减员备注">
                  {{ personDetial.attrtionDes || '' }}
                </a-descriptions-item>
              </a-descriptions>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- 开具材料情况 -->
    <div class="detial-cont" v-if="organizationId == 100101">
      <div class="detial-cont-title">开具材料情况</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <materialsTable
          v-model="personDetial.personnelManagerScienceList"
          :file="personDetial.personnelManagerScienceList"
          :id="id"
          :disabled="true"
        ></materialsTable>
      </div>
    </div>
    <appfloor v-if="version || year || month"></appfloor>
    <bottomSuspension v-else>
      <a-button :style="{ marginRight: '26px' }" @click="goback">
        返回
      </a-button>
      <!-- <a-button
        type="primary"
        :style="{ marginRight: '42px' }"
        @click="setpop()"
      >
        减员
      </a-button> -->
    </bottomSuspension>

    <a-modal
      v-model="ispop"
      title="减员操作"
      @ok="handleOk"
      :confirm-loading="confirmLoading"
    >
      <prompts> 请选择减员原因，并填写减员备注信息</prompts>
      <div class="dep-form">
        <div class="dep-form-item">
          <div class="dep-form-lable">减员原因：</div>
          <a-radio-group v-model="delData.positionStatus">
            <template v-for="item in positionStatusList">
              <a-radio
                :value="item.valuename"
                :key="item.id"
                v-if="item.valuename !== '1001'"
              >
                {{ item.keyname }}
              </a-radio>
            </template>
          </a-radio-group>
        </div>
        <blank height="25"> </blank>
        <div class="dep-form-item">
          <div class="dep-form-lable">减员备注：</div>
        </div>
        <div class="dep-form-item">
          <a-input
            v-model="delData.cause"
            type="textarea"
            class="w500"
            :auto-size="{ minRows: 4, maxRows: 6 }"
          />
        </div>
      </div>
    </a-modal>
    <print v-model="isPrint">
      <div v-if="printKey === '1'">
        <blank height="30"> </blank>
        <div class="print-title">北京市民政工业总公司职工个人信息表</div>
        <div class="print-border">
          <div class="Pprintd-cont-title">基本信息</div>
          <a-descriptions bordered size="small" :column="4">
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">姓名</div>
              <div class="printCenter">
                {{ personDetial.fullName }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">性别</div>
              <div class="printCenter">
                {{ personDetial.sex }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">身份证号码</div>
              <div class="printCenter">
                {{ personDetial.idCardNumber }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">出生年月</div>
              <div class="printCenter">
                {{
                  personDetial.birthTime_s
                    ? personDetial.birthTime_s.substring(0, 8)
                    : ''
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">年龄</div>
              <div class="printCenter">{{ personDetial.age }}岁</div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">民族</div>
              <div class="printCenter">
                {{ personDetial.nation }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">籍贯</div>
              <div class="printCenter">
                {{ personDetial.nativePlace }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">出生地</div>
              <div class="printCenter">
                {{ personDetial.birthplace }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">政治面貌</div>
              <div class="printCenter">
                {{
                  getByTypeName(personDetial.politicalType, politicalTypeList)
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">入党时间</div>
              <div class="printCenter">
                {{
                  personDetial.joinPartyTime_s
                    ? personDetial.joinPartyTime_s.substring(0, 8)
                    : ''
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">户口所在地</div>
              <div class="printCenter">
                {{ personDetial.registeredResidence }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">户口性质</div>
              <div class="printCenter">
                {{
                  getByTypeName(
                    personDetial.registeredNature,
                    registeredNatureList
                  )
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">健康状况</div>
              <div class="printCenter">
                {{ getByTypeName(personDetial.healthStatus, healthStatusList) }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">联系电话</div>
              <div class="printCenter">
                {{ personDetial.phone }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">家庭地址</div>
              <div class="printCenter">
                {{ personDetial.homeAddress || '' }}
              </div>
            </a-descriptions-item>
          </a-descriptions>
          <div class="Pprintd-cont-title">学历信息</div>
          <a-descriptions bordered size="small" :column="2">
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">全日制教育</div>
                <div class="printCenter fwLabel">学历学位</div>
              </div>
              <div class="printCenter">
                {{ getByTypeName(personDetial.firstEducation, educationList) }}
              </div>
              <div class="printCenter">
                {{ personDetial.firstAcademicDegree || '' }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">全日制教育</div>
                <div class="printCenter fwLabel">毕业院校系及专业</div>
              </div>
              <div class="printCenter">
                {{ personDetial.firstGraduationSchool || '' }}
              </div>
              <div class="printCenter">{{ personDetial.firstMajor || '' }}</div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">在职教育</div>
                <div class="printCenter fwLabel">学历学位</div>
              </div>
              <div class="printCenter">
                {{ getByTypeName(personDetial.education, educationList) }}
              </div>
              <div class="printCenter">
                {{ personDetial.academicDegree || '' }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">在职教育</div>
                <div class="printCenter fwLabel">毕业院校系及专业</div>
              </div>
              <div class="printCenter">
                {{ personDetial.graduationSchool || '' }}
              </div>
              <div class="printCenter">{{ personDetial.major || '' }}</div>
            </a-descriptions-item>
          </a-descriptions>
          <div class="Pprintd-cont-title">工作信息</div>
          <a-descriptions bordered size="small" :column="3">
            <a-descriptions-item span="3">
              <div slot="label" class="printCenter fwLabel">所在部门</div>
              <div class="printCenter">
                {{ personDetial.organizationName || '' }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">行政职务</div>
              <div class="printCenter">
                {{ getByTypeName(personDetial.position, positionList) }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">任现职务时间</div>
              <div class="printCenter">
                {{ personDetial.positionTime_s || '' }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">任现职务年限</div>
              <div class="printCenter">
                {{ personDetial.positionAge || '' }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">职级</div>
              <div class="printCenter">
                {{
                  getByTypeName(personDetial.positionLevel, positionLevelList)
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">任现职级时间</div>
              <div class="printCenter">
                {{ personDetial.positionLevelTime_s || '' }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">任现职级年限</div>
              <div class="printCenter">
                {{ personDetial.positionLevelAge || '' }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">技术职称</div>
              <div class="printCenter">
                {{ personDetial.technicalTitle || '' }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">职称聘任时间</div>
              <div class="printCenter">
                {{
                  personDetial.appointmentTime_s
                    ? personDetial.appointmentTime_s.substring(0, 8)
                    : ''
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">职称获得时间</div>
              <div class="printCenter">
                {{
                  personDetial.acquisitionTime_s
                    ? personDetial.acquisitionTime_s.substring(0, 8)
                    : ''
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item span="1.5">
              <div slot="label" class="printCenter fwLabel">
                首次参加工作时间
              </div>
              <div class="printCenter">
                {{ personDetial.firstWorkTime_s || '' }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item span="1.5">
              <div slot="label" class="printCenter fwLabel">总工龄</div>
              <div class="printCenter">
                {{ personDetial.totalSystemAge || '' }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item span="1.5">
              <div slot="label" class="printCenter fwLabel">
                进入本公司机关时间
              </div>
              <div class="printCenter">
                {{ personDetial.currentOfficeSysTime_s || '' }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item span="1.5">
              <div slot="label" class="printCenter fwLabel">本单位工龄</div>
              <div class="printCenter">
                {{ personDetial.currentOfficeSysAge || '' }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item span="1.5">
              <div slot="label" class="printCenter fwLabel">
                进入民政系统时间
              </div>
              <div class="printCenter">
                {{ personDetial.civilOfficeSysTime_s || '' }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item span="1.5">
              <div slot="label" class="printCenter fwLabel">
                进入本公司系统时间
              </div>
              <div class="printCenter">
                {{ personDetial.headOfficeSysTime_s || '' }}
              </div>
            </a-descriptions-item>
          </a-descriptions>
          <div class="Pprintd-cont-title">退休信息</div>

          <a-descriptions bordered size="small" :column="4">
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">退休前职务</div>
              </div>
              {{ personDetial.retirePosition || '' }}
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">退休时间</div>
              </div>
              {{ personDetial.retireTime || '' }}
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">退休时身份</div>
              </div>
              {{ personDetial.retireIdentity || '' }}</a-descriptions-item
            >
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">退休类别</div>
              </div>
              {{ getByTypeName(personDetial.retireType, retireTypeList) }}
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">退休人员</div>
                <div class="printCenter fwLabel">档案号</div>
              </div>
              {{ personDetial.retireNumber || '' }}</a-descriptions-item
            >
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">是否社会</div>
                <div class="printCenter fwLabel">化管理</div>
              </div>
              {{ personDetial.socialManagement || '' }}
            </a-descriptions-item>

            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">减员备注</div>
              </div>
              {{ personDetial.description || '' }}
            </a-descriptions-item>
          </a-descriptions>
        </div>
      </div>
      <div v-if="printKey === '2'">
        <blank height="30"> </blank>
        <div class="print-border print-poths">
          <div class="print-title">个 人 履 历</div>
          <div class="haveImg">
            <div class="haveImg-left">
              <a-descriptions bordered size="small" :column="3">
                <a-descriptions-item>
                  <div slot="label" class="printCenter fwLabel">姓名</div>
                  <div class="printCenter">
                    {{ personDetial.fullName || '' }}
                  </div>
                </a-descriptions-item>
                <a-descriptions-item>
                  <div slot="label" class="printCenter fwLabel">性别</div>
                  <div class="printCenter">
                    {{ personDetial.sex || '' }}
                  </div>
                </a-descriptions-item>
                <a-descriptions-item>
                  <div slot="label">
                    <div class="printCenter fwLabel">出生年月</div>
                    <div class="printCenter fwLabel">(岁)</div>
                  </div>
                  <div class="printCenter">
                    {{ personDetial.birthTime_s || '' }}
                  </div>
                  <div class="printCenter">
                    ({{ personDetial.age || '' }}岁)
                  </div>
                </a-descriptions-item>
                <a-descriptions-item>
                  <div slot="label" class="printCenter fwLabel">民族</div>
                  <div class="printCenter">
                    {{ personDetial.nation || '' }}
                  </div>
                </a-descriptions-item>
                <a-descriptions-item>
                  <div slot="label" class="printCenter fwLabel">籍贯</div>
                  <div class="printCenter">
                    {{ personDetial.nativePlace || '' }}
                  </div>
                </a-descriptions-item>
                <a-descriptions-item>
                  <div slot="label" class="printCenter fwLabel">出生地</div>
                  <div class="printCenter">
                    {{ personDetial.birthplace || '' }}
                  </div>
                </a-descriptions-item>
                <a-descriptions-item>
                  <div slot="label" class="printCenter fwLabel">政治面貌</div>
                  <div class="printCenter">
                    {{
                      getByTypeName(
                        personDetial.politicalType,
                        politicalTypeList
                      )
                    }}
                  </div>
                </a-descriptions-item>
                <a-descriptions-item>
                  <div slot="label" class="printCenter fwLabel">入党时间</div>
                  <div class="printCenter">
                    {{
                      personDetial.joinPartyTime_s
                        ? personDetial.joinPartyTime_s.substring(0, 8)
                        : ''
                    }}
                  </div>
                </a-descriptions-item>
                <a-descriptions-item>
                  <div slot="label" class="printCenter fwLabel">健康状况</div>
                  <div class="printCenter">
                    {{
                      getByTypeName(personDetial.healthStatus, healthStatusList)
                    }}
                  </div>
                </a-descriptions-item>
              </a-descriptions>
            </div>
            <div
              class="isImg"
              :style="isPrint.printTitle == 'pdf' ? 'height:139px' : ''"
            >
              <span>照片</span>
            </div>
          </div>
          <a-descriptions
            style="margin-top: -2px; z-index: 200"
            bordered
            size="small"
            :column="2"
          >
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">技术职称</div>
              </div>
              <div class="printCenter">
                {{ personDetial.technicalTitle || '' }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">参加工作时间</div>
              </div>
              <div class="printCenter">
                {{ personDetial.firstWorkTime_s || '' }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">进入本单位时间</div>
              </div>
              <div class="printCenter">
                {{ personDetial.currentOfficeSysTime_s || '' }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">总工龄</div>
              </div>
              <div class="printCenter">
                {{ personDetial.totalSystemAge || '' }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">全日制教育</div>
                <div class="printCenter fwLabel">学历学位</div>
              </div>
              <div class="printCenter">
                {{ getByTypeName(personDetial.firstEducation, educationList) }}
              </div>
              <div class="printCenter">
                {{ personDetial.firstAcademicDegree || '' }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">全日制教育</div>
                <div class="printCenter fwLabel">毕业院校系及专业</div>
              </div>
              <div class="printCenter">
                {{ personDetial.firstGraduationSchool || '' }}
              </div>
              <div class="printCenter">{{ personDetial.firstMajor || '' }}</div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">在职教育</div>
                <div class="printCenter fwLabel">学历学位</div>
              </div>
              <div class="printCenter">
                {{ getByTypeName(personDetial.education, educationList) }}
              </div>
              <div class="printCenter">
                {{ personDetial.academicDegree || '' }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">在职教育</div>
                <div class="printCenter fwLabel">毕业院校系及专业</div>
              </div>
              <div class="printCenter">
                {{ personDetial.graduationSchool || '' }}
              </div>
              <div class="printCenter">{{ personDetial.major || '' }}</div>
            </a-descriptions-item>
            <a-descriptions-item span="2">
              <div slot="label" class="printCenter fwLabel">现任职务</div>
              <div class="printCenter">
                <span v-if="getIsLead() != -1">
                  北京市民政工业总公司{{
                    getByTypeName(personDetial.position, positionList)
                  }}
                </span>
                <span v-else>
                  北京市民政工业总公司{{ personDetial.organizationName || ''
                  }}{{ getByTypeName(personDetial.position, positionList) }}
                </span>
              </div>
            </a-descriptions-item>
            <a-descriptions-item span="2">
              <div slot="label" class="printCenter fwLabel">任现职务时间</div>
              <div class="printCenter">
                {{ personDetial.positionTime_s || '' }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item span="2">
              <div slot="label" class="printCenter fwLabel">现任职级</div>
              <div class="printCenter">
                {{
                  getByTypeName(personDetial.positionLevel, positionLevelList)
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item span="2">
              <div slot="label" class="printCenter fwLabel">任现职级时间</div>
              <div class="printCenter">
                {{ personDetial.positionLevelTime_s || '' }}
              </div>
            </a-descriptions-item>
          </a-descriptions>
          <a-descriptions
            style="margin-top: -4px"
            bordered
            size="small"
            :column="1"
          >
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">履</div>
                <blank height="60"> </blank>
                <div class="printCenter fwLabel">历</div>
              </div>

              <blank height="200" style="width: 250px"> </blank>
            </a-descriptions-item>
          </a-descriptions>
        </div>
      </div>
    </print>
  </div>
</template>

<script>
import {
  personnelGet,
  personnelManagerRetirePersonnelGet,
  updatePositionStatus,
  getHistoryDetial,
  getJobDetial
} from '../api/api'
import { formatDateNoDetails } from '@/assets/js/auth'
import { mapState, mapActions } from 'vuex'
import materialsTable from '../TheDead/components/materials-table.vue'
export default {
  components: {
    materialsTable
  },
  data() {
    return {
      confirmLoading: false,
      ispop: false, // 减员弹窗
      // isPrint: false, // 打印弹窗
      isPrint: {
        printStatus: false,
        printTitle: ''
      }, // 打印弹窗
      printKey: '1', //1对内版本，2对外版本
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      personDetial: {}, // 详情
      delData: {}, // 减员操作信息
      id: '',
      version: '', //历史版本
      year: '', // 年
      month: '' // 月
    }
  },
  computed: {
    organizationId() {
      return this.$store.state.app.userInfo.tenantId
    },
    ...mapState({
      positionList: (state) => state.bytype.positionList, //行政职务
      positionLevelList: (state) => state.bytype.positionLevelList, //职级
      politicalTypeList: (state) => state.bytype.politicalTypeList, //政治面貌
      contractTypeList: (state) => state.bytype.contractTypeList, //劳动合同类型
      educationList: (state) => state.bytype.educationList, //学历
      registeredNatureList: (state) => state.bytype.registeredNatureList, //户口性质
      healthStatusList: (state) => state.bytype.healthStatusList, //健康状况
      positionStatusList: (state) => state.bytype.positionStatusList, //减员原因
      retireTypeList: (state) => state.bytype.retireTypeList // 退休类别
    })
  },
  created() {
    this.id = this.$route.query.id
    this.version = this.$route.query.version ? this.$route.query.version : ''
    this.year = this.$route.query.year ? this.$route.query.year : ''
    this.month = this.$route.query.month ? this.$route.query.month : ''
    if (this.version) {
      //历史修改版本
      getHistoryDetial({ id: this.id, version: this.version }).then((res) => {
        if (res.data.code == 0) {
          this.personDetial = res.data.data
        }
      })
    } else if (this.year && this.month) {
      //历史版本
      getJobDetial({ id: this.id, year: this.year, month: this.month }).then(
        (res) => {
          if (res.data.code == 0) {
            this.personDetial = res.data.data
          }
        }
      )
    } else {
      // 正常详情 personnelManagerRetirePersonnelGet personnelGet
      personnelManagerRetirePersonnelGet(this.id).then((res) => {
        if (res.data.code == 0) {
          this.personDetial = res.data.data
        }
      })
    }
    this.getByType()
  },
  methods: {
    ...mapActions([
      'getposition',
      'getpositionLevel',
      'getpoliticalType',
      'getcontractType',
      'geteducation',
      'getregisteredNature',
      'getpositionStatus',
      'gethealthStatus',
      'getRetireTypeList'
    ]),
    formatDateIt(data) {
      // 时间格式化
      return formatDateNoDetails(data)
    },
    //通过字典值过去字典名
    getByTypeName(value, list) {
      let byType = list.find((item) => {
        return item.valuename == value
      })
      if (byType) {
        return byType.keyname
      } else {
        return value
      }
    },
    // 获取当前页面所需字典表
    getByType() {
      //减员原因
      this.getpositionStatus()
      //行政职务
      this.getposition()
      //职级
      this.getpositionLevel()
      //政治面貌
      this.getpoliticalType()
      //劳动合同类型
      this.getcontractType()
      //学历
      this.geteducation()
      //户口性质
      this.getregisteredNature()
      //健康状况
      this.gethealthStatus()
      // 退休类别
      this.getRetireTypeList()
    },
    setpop() {
      this.ispop = true
    },
    handleOk(e) {
      // 确定减员
      this.confirmLoading = true
      let params = this.delData
      params.id = this.id
      updatePositionStatus(params).then((res) => {
        if (res.data.code == 0) {
          this.$message.success('减员操作成功')
          this.ispop = false
          this.goback()
          this.confirmLoading = false
        } else {
          this.confirmLoading = false
        }
      })
    },
    goback() {
      this.$router.back()
    },
    handleMenuClick(e) {
      let key = e.key.split('_')
      this.printKey = key[0]
      this.isPrint = {
        printTitle: key[1]
      }
      this.setisPrint()
    },
    //获取是否 是领导
    getIsLead() {
      //总经理、副总经理、总经理助理、党委书记、党委副书记、纪委书记、纪委副书记、工会主席
      //北京园福源物业管理有限公司党总支副书记、经理、团委书记（不是领导)；
      let IsLeadList = [
        '1300',
        '1305',
        '1310',
        '1315',
        '1320',
        '1325',
        '1330',
        '1335',
        '1340',
        '1345',
        '1350'
      ]
      let IsLead = IsLeadList.indexOf(this.personDetial.position)
      // console.log(IsLead); // IsLead为-1  不是领导
      return IsLead
    },
    setisPrint() {
      this.isPrint.printStatus = true
      if (this.printKey === '1') {
        //对内
        document.title =
          '人员信息表-' +
          this.personDetial.fullName +
          this.$printFormatDate(new Date())
      } else {
        document.title =
          '个人履历表-' +
          this.personDetial.fullName +
          this.$printFormatDate(new Date())
      }
    }
  }
}
</script>
<style scoped>
.print-border {
  height: auto;
  overflow: hidden;
  font-family: '宋体';
  margin: 0px 30px 20px 30px;
  background-color: #333333 !important;
}
/deep/ .ant-descriptions-view table {
  border-collapse: separate;
}
.Pprintd-cont-title {
  border: 2px solid #333333;
  border-bottom: 0;
  border-top: 0;
}
.Pprintd-cont-title:nth-child(1) {
  border: 2px solid #333333;
  border-bottom: 0;
}
/deep/ .ant-descriptions-view table tbody tr th,
/deep/ .ant-descriptions-view table tbody tr td {
  border: none !important;
  border: 0 !important;
  background: #fff;
}
/deep/ .ant-descriptions-view table tbody tr {
  border: none !important;
  border: 0 !important;
}
.print-poths .print-title,
.print-poths .isImg {
  background-color: #fff !important;
}
</style>
<style lang="scss" scoped>
.detial-top {
  background: #fff;
  padding: 0 50px 50px 50px;
  position: relative;
  .detial-top-btn {
    position: absolute;
    right: 90px;
    top: 0;
  }
}
.detial-cont {
  margin: 24px 16px;

  .detial-cont-title {
    background: #fff;
    height: 55px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    line-height: 55px;
    text-align: left;
    padding-left: 32px;
  }
  .detial-cont-view {
    background: #fff;
    padding: 30px;
    .personage {
      // height: 360px;
      border: #e9e9e9 solid 1px;
      border-radius: 4px;
      .personage-title {
        padding-left: 24px;
        height: 44px;
        color: rgba(0, 0, 0, 0.85);
        background-color: rgba(250, 250, 250, 1);
        border-bottom: #e9e9e9 solid 1px;
        border-radius: 4px;
        font-size: 14px;
        line-height: 44px;
      }
      .personage-cont {
        padding: 16px 24px 0 24px;
      }
    }
  }
}

.dep-form {
  width: 468px;
  margin-top: 40px;
  .dep-form-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .dep-form-lable {
      width: 70px;
      height: 21px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      line-height: 21px;
      text-align: left;
    }
  }
  .operating-checkbox-btn {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.print-scrollY {
  overflow-y: scroll;
  max-height: calc(100vh - 400px);
}
// .print-scrollY::-webkit-scrollbar {
//   display: none;
// }
// 打印内容不能嵌套写样式
.print-title {
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  height: 50px;
  line-height: 50px;
  font-family: '宋体';
}
.Pprintd-cont-title {
  text-align: center;
  background-color: rgb(191, 191, 191);
  height: 40px;
  line-height: 40px;
  font-weight: 700;
  font-size: 18px;
  // border-bottom: 3px solid #c3c3c3;
}
.printCenter {
  text-align: center;
  color: #000000;
}
.haveImg {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  // border: 1px solid #c3c3c3;
}
.haveImg-left {
  width: 87%;
}
.isImg {
  height: 136px;
  width: 13%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 2px solid #333;
  border-right: 2px solid #333;
  z-index: 100;
}
.fwLabel {
  font-weight: 800;
}
</style>
<style lang="scss">
.haveImg-left {
  .ant-descriptions-view {
    border-bottom: none !important;
  }
}
.ant-descriptions-view {
  // border: none;
  border-radius: 0px !important;
}
.ant-descriptions-bordered .ant-descriptions-item-label {
  background-color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/views/PersonnelManagement/TheRetiree/detail copy(备份：没有封装打印组件).vue